/* src/app/global/components/global-help/global-help-menu/global-help-menu.component.scss */
:host .cw-flex-column {
  height: 100%;
}
:host .lists {
  flex: 1;
  overflow-y: auto;
}
/*# sourceMappingURL=global-help-menu.component.css.map */
